import { createActionGroup, props } from '@ngrx/store'

import { AgentName } from '@flowx/designer/modules/ai/conversation/ai-conversation.commons'

export enum ConversationErrorContext {
  NewConversation = 'new_conversation',
  DefaultThreadMessage = 'default_thread_message',
  SystemMessage = 'system_message',
}

export enum ExecutionPlanUpdateType {
  Keep = 'keep',
  Delete = 'delete',
  ApplySuggestions = 'apply_suggestions',
}

export const ConversationErrorActions = createActionGroup({
  source: 'Conversation Error',
  events: {
    intentUnderstandingFailed: props<{
      error: Error
      context: ConversationErrorContext
      conversationId?: string
      threadId?: string
    }>(),

    executionPlanImplementActionFailed: props<{
      error: Error
      actionId: string
      messageId: string
      threadId?: string
      conversationId?: string
    }>(),

    keepOutcomeFailed: props<{
      error: Error
      threadId: string
      conversationId: string
    }>(),

    executionPlanUpdateFailed: props<{
      error: Error
      updateType: ExecutionPlanUpdateType
      conversationId?: string
      threadId?: string
    }>(),

    agentMessageFailed: props<{
      error: Error
      threadId: string
      conversationId: string
    }>(),

    simpleThreadFailed: props<{
      error: Error
      agentName: string
      conversationId?: string
    }>(),

    conversationCreationFailed: props<{
      error: Error
    }>(),

    conversationLoadFailed: props<{
      error: Error
      conversationId: string
    }>(),

    conversationEvicted: props<{ conversationId: string }>(),

    actionPatchFailed: props<{
      error: Error
      actionId: string
      messageId: string
      conversationId?: string
    }>(),

    agentOutcomeParsingFailed: props<{
      error: Error
      agentName: AgentName
      messageId: string
      threadId?: string
      conversationId?: string
    }>(),

    generateUiFromNodeActionFailed: props<{
      error: Error
    }>(),

    fileUploadFailed: props<{
      error: Error
      conversationId?: string
    }>(),

    updateDataModelFailed: props<{
      error: Error
      conversationId: string
      threadId: string
      messageId: string
    }>(),
  },
})
